import React from 'react';
import { ThresholdsMeta } from '@src/utils/kpi';
import { Select } from 'antd';
import { updateSelectedConfig } from '@store/overviewDashboard/spiThresholds/actions';
import { useDispatch } from 'react-redux';
import { PopUpMetric, MetricName, MetricUnit, MetricSign } from '../styled';
import { renameAllShortInAString, renameVideoToStream } from '@src/utils/common';

const MetricSlider = ({ isEditable, metricKey, metricValue }) => {
  const dispatch = useDispatch();

  const renderSelect = () => {
    const { Option } = Select;
    return ThresholdsMeta[metricKey].bucket.map((item, index) => (
      <Option key={index} value={Number(item)}>
        {Number(item)}
      </Option>
    ));
  };

  const onChange = (value) => {
    dispatch(
      updateSelectedConfig({
        key: metricKey,
        value,
      }),
    );
  };

  let displayName = ThresholdsMeta[metricKey]?.displayName;
  displayName = renameAllShortInAString(renameVideoToStream(displayName));

  return (
    <PopUpMetric>
      <MetricName>{displayName || metricKey}</MetricName>
      <MetricUnit>
        <MetricSign> {ThresholdsMeta[metricKey]?.threshold} </MetricSign>
        <Select value={metricValue} onChange={onChange} disabled={!isEditable}>
          {renderSelect()}
        </Select>
        <span style={{ padding: '3px 10px' }}>{ThresholdsMeta[metricKey]?.unit || ''}</span>
      </MetricUnit>
    </PopUpMetric>
  );
};

export default MetricSlider;
